/* ... . .-. --. . / --.. .... ..- .-. .- ...- .-.. . ...- */
/* Google maps */
function initMap() {
	var mapContainer = document.getElementById("map");

	if (mapContainer.classList.contains('is-active')) {
		return;
	}

	var CenterList = [
		{ lat: 25.118689, lng: 55.377481, zoom: 17},
		{ lat: 40.500773, lng: -74.847324, zoom: 17 },
		{ lat: 47.227262, lng: 39.706049, zoom: 14 }, 
		{ lat: 47.419754, lng: 40.079630, zoom: 14 },
		{ lat: 59.933335, lng: 30.344628, zoom: 15 }
	];

	var map = new google.maps.Map(mapContainer, {
		zoom: CenterList[0].zoom,
		center: { lat: CenterList[0].lat, lng: CenterList[0].lng },
		mapTypeControl: true,
		mapTypeControlOptions: {
			style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
			position: google.maps.ControlPosition.TOP_CENTER
		},
		zoomControl: true,
		zoomControlOptions: {
			position: google.maps.ControlPosition.LEFT_CENTER
		},
		scaleControl: true,
		streetViewControl: true,
		streetViewControlOptions: {
			position: google.maps.ControlPosition.LEFT_TOP
		}
	});

	//window.slcodemap = map;

	var image = "/images/marker.png";
	var MarkerList = [new google.maps.Marker({
		position: CenterList[0],
		map: map,
		icon: image
	}), new google.maps.Marker({
		position: CenterList[1],
		map: map,
		icon: image
	}), new google.maps.Marker({
		position: CenterList[2],
		map: map,
		icon: image
	}), new google.maps.Marker({
		position: CenterList[3],
		map: map,
		icon: image
	})];

	$('.js-contact-address').each(function (i, el) {
		$(el).click(function () {
			$('.js-contact-address').removeClass('is-active');
			$(el).addClass('is-active');
			var c = CenterList[i];
			map.setCenter({
				lat: c.lat,
				lng: c.lng
			});
			map.setZoom(c.zoom);
		});
	});

	mapContainer.classList.add('is-active');
}


function startPreloader() {
	$('.logo').addClass('animations-ready');
	setTimeout(() => {
		$('body').removeClass('is-preloading');

		setTimeout(() => {
			$('body').removeClass('is-first-loading');
		}, 600);

	}, 1400);
}

/* open images by click */
function magnifyImage(e) {
	const
		page = $(this).closest('.page'),
		imageList = page[0].querySelectorAll('*[data-magnify]'),
		sliderContainer = document.querySelector('.js-magnify-slider'),
		imageArray = Array.prototype.slice.call(imageList),
		clickIndex = imageArray.indexOf(e.target),
		imageOverlay = document.querySelector('#image-overlay');

	imageArray.forEach(item => {
		const
			itemWrapper = document.createElement('div'),
			fakeItem = item.cloneNode(true),
			src = item.getAttribute('src'),
			image = document.createElement('img');

		image.setAttribute('src', src);


		itemWrapper.appendChild(image);
		itemWrapper.classList.add('image-overlay__slider-item');
		itemWrapper.classList.add('js-image-overlay-item');
		itemWrapper.setAttribute('data-src', src);
		sliderContainer.appendChild(itemWrapper);
	});

	$(sliderContainer).slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		initialSlide: clickIndex,
		nextArrow: document.getElementById('overlay-click-prev'),
		prevArrow: document.getElementById('overlay-click-next'),
	});

	$(sliderContainer).slick("refresh");

	// $(sliderContainer).slick('slickGoTo', clickIndex);

	$(imageOverlay).addClass('is-active');
};

function magnifyImages() {
	/* get images that can be opened by click */
	var minimizedImg = document.querySelectorAll('.minimized:not(.is-active)');
	minimizedImg.forEach(item => {
		item.classList.add('is-active');
		item.addEventListener('click', magnifyImage);
	});
}

var lastSearchQuery = null,
	searchHandler = null;

function clearSearch() {
	$('.search .search__input').blur();
	$('.search').removeClass('is-active');
	$('body').removeClass("is-overlay-search");
	$('.search .search__input').val('');
	// clear search result
	$('.overlay-search .result').html('');
	lastSearchQuery = null;
	clearInterval(searchHandler);
	searchHandler = null;
}

function toggleTabs() {
	$('.js-tabs-link').on('click', function () {
		var $this = $(this),
			$tabs = $this.closest('.js-tabs'),
			id = $this.attr('data-tab');

		$tabs.find('[data-tab]').removeClass('is-active');
		$tabs.find('[data-tab= ' + id + ']').addClass('is-active');
	});
}

function initMaster() {
	/* magnifyImage variables */
	const
		imageOverlay = document.querySelector('#image-overlay'),
		closeImageOverlay = document.querySelector('#close-image-overlay');

	/* remove image slider */
	closeImageOverlay.addEventListener('click', () => {
		document.querySelector('.js-magnify-slider').innerHTML = '';
		imageOverlay.classList.remove('is-active');
	});

	/* hide image overlay */
	imageOverlay.addEventListener('click', (e) => {
		const
			{ target } = e,
			{ dataset } = target,
			{ role } = dataset;

		if (role === 'close') {
			e.target.classList.remove('is-active');
			$(document.querySelector('.js-magnify-slider')).slick('unslick');
			document.querySelector('.js-magnify-slider').innerHTML = '';
		}
	});

	document.addEventListener('click', (e) => {
		if(e.target.closest('.js-image-overlay-item')){
			let src = e.target.closest('.js-image-overlay-item').getAttribute('data-src')
			window.location = src;
		}
	});

	// handle menu
	$(".js-toggle-menu").on("click", function (event) {
		$('body').toggleClass("is-overlay-menu");
		$(event.currentTarget).closest('.navigation-btn').toggleClass("is-active");
	});

	// handle search
	$('.js-toggle-search').on('click', function (event) {
		if (!$('.search').hasClass('is-active')) {
			clearSearch();
			$('.search').addClass('is-active');	
			setTimeout(function(){
				$('.search .search__input').focus();
			}, 300)
			searchHandler = setInterval(_ => {
				var searchQuery = $('.search .search__input').val().replace(/^\s+/, '').replace(/\s+$/, '');

				if (searchQuery.length == 0) {
					// clear search result
					$('.overlay-search .result').html('');
					lastSearchQuery = null;
					return;
				}

				if (searchQuery == lastSearchQuery) {
					return;
				}

				lastSearchQuery = searchQuery;

				var ajaxService = new Api({ fetch: jQuery.ajax });
				ajaxService.getHtml('/gethtml/search?q=' + encodeURIComponent(searchQuery)).done(html => {
					if ($('.search .search__input').val().replace(/^\s+/, '').replace(/\s+$/, '') == searchQuery) {
						$('body').addClass("is-overlay-search");
						$('.overlay-search .result').html($(html).find('.result').html());
						lastSearchQuery = searchQuery;
					}
				});
			}, 200);
		} else {
			$('.search .search__input').blur();
			$('.search').removeClass('is-active');
		}
	});

	$('.js-close-search').on('click', function (event) {
		clearSearch();
	});

	/*links*/
	document.querySelectorAll('[data-url]').forEach((item, i, arr) => {
	    item && item.addEventListener('click', goTo);
	});

	/*toggle tabs*/
	toggleTabs();

	/*animations*/
	window.logoPosition();

	window.addEventListener('resize', (e) => {
		window.logoPosition();	
	})

	document.querySelector('.wrapper').addEventListener('scroll', (e) =>{
        window.parallax();
        window.animateOnScroll();
        window.logoTransform();
    });	

}

function isInViewport(el, offset) {
    const distance = el.getBoundingClientRect();
    
    return (
        distance.top + offset <= (window.innerHeight || document.documentElement.clientHeight)
    );
};

window.animateOnScroll = function() {
    document.querySelectorAll('.page.is-active .js-aos').forEach((el) => {
        let elOffset = +el.getAttribute('data-offset') || 0;

        if (isInViewport(el, elOffset)) {
            el.classList.add('is-animated');
        }
    });
}

window.parallax = function() {
    document.querySelectorAll('.js-parallax').forEach((el) => {
        const   boxScrollTop = el.closest('.js-parallax-wrap').offsetTop,
                boxOffset = el.getAttribute('data-offset') ? el.getAttribute('data-offset') : 0,
                scrollTop = document.querySelector('.wrapper').scrollTop - (boxScrollTop - boxOffset),
                speed = el.getAttribute('data-speed') ? el.getAttribute('data-speed') : .5;

        el.style.transform = 'translateY(-' + (scrollTop * speed) + 'px)';
    });
}

window.logoPosition = function(){
	const logo = document.querySelector('.js-logo');

	if (document.documentElement.clientWidth > 1023 && document.querySelector('body').classList.contains('page-index')){
    	var projectsPosition = document.querySelector('.intro-projects').getBoundingClientRect().top;
		logo.style.top = (projectsPosition > 170 ? projectsPosition : 170) + 'px';
    } else {
    	logo.style.top = ''
    }
}

window.logoTransform = function(){
	if(document.documentElement.clientWidth > 1023 && document.querySelector('body').classList.contains('page-index')){
    	var scrollTop = document.querySelector('.wrapper').scrollTop;

    	document.querySelector('.js-logo').style.transform = 'translateY(-' + scrollTop + 'px)';
    } else {
    	document.querySelector('.js-logo').style.transform = ''
    }
}

function goTo(event){
	event.stopPropagation();
	event.preventDefault();

	const elt = event.currentTarget;
	window.open(elt.dataset.url, '_blank')	
}

function highlightSyntax() {
	Prism.manual = true;

	document.querySelectorAll('pre code').forEach((block) => {
		if (!block.classList.contains('highlighted')) {
			Prism.highlightElement(block);
			block.classList.add('highlighted');
		}
	});
}

function toggleDropdown(){
	$('.js-dropdown-toggle').each(function (i, el) {
		$(el).click(function (e) {
			e.preventDefault();
			
			let id = $(el).attr('data-drop');

			$('.js-dropdown[data-drop="' + id + '"]').slideToggle();
		});
	});
}

window.initIndex = function () {
	if (location.pathname == "/") {
		startPreloader();
	}
}

window.initWhyus = function () {
}

window.initSolutions = function () {
}

window.initAbout = function () {
	magnifyImages();

	/* slider on the about page */
	var imagesContainer = $(".js-slider-company:not(.is-active)");
	imagesContainer.slick({
		useTransform: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		speed: 500,
		prevArrow: ".js-slider-company-prev",
		nextArrow: ".js-slider-company-next",
		cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)', /* easeInOutQuart */
		responsive: [
		    {
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
		    },
		    {
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
		    }
	    ]
	});
	imagesContainer.addClass('is-active');
	imagesContainer.on('beforeChange', function(event, slick, currentSlide, nextSlide){
		if(nextSlide>currentSlide){
			imagesContainer.addClass('is-animate-forward')	
		} else {
			imagesContainer.addClass('is-animate-backward')	
		}
	});
	imagesContainer.on('afterChange', function(event, slick, currentSlide, nextSlide){
		imagesContainer.removeClass('is-animate-forward is-animate-backward')
	});
}

window.initContacts = function () {
	initMap();
}

window.initPortfolio = function () {
	magnifyImages();
	toggleTabs();
}

window.initArticle = function () {
	magnifyImages();
	highlightSyntax();
	toggleDropdown();
}

/* DOMReady */
document.addEventListener("DOMContentLoaded", () => {
	initMaster();

	// init router
	window.__CLIENT_ROUTER = new Router({ routeSelectorMask: '.page', linkSelector: '.lnk', ajaxService: new Api({ fetch: jQuery.ajax }) });
	window.back = () => history.back();
	window.forward = () => history.forward();
});
